module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_NB3-p25_April1959.c07176e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_NB3-p25_April1959.jpg
// module id = 5srD
// module chunks = 0